import { ContactDetailsState, RootState } from '@/store';

export const getContactDetails = (state: RootState): ContactDetailsState => state.contactDetails;
